import React from "react"
import logo from "assets/ebate-loader.gif"
import { StyledCardGridLayoutContainer } from "./styled"

const CardGridLayoutContainer = (props) => {
  const { id, cardView, grid, cards, isLoading, className } = props

  return (
    <StyledCardGridLayoutContainer id={id} className={className}>
      <div>
        <div
          className={cardView ? "transition-visible" : "transition-hidden"}
          style={{ display: cardView ? "block" : "none" }}
        >
          {cards}
        </div>

        <div
          className={!cardView ? "transition-visible" : "transition-hidden"}
          style={{ display: !cardView ? "block" : "none" }}
        >
          {grid}
        </div>

        {isLoading && (
          <div className="spinnerContainer">
            <img
              src={logo}
              alt="Loading..."
              id="imgLoadMore"
              height="100"
              width="100"
            />
          </div>
        )}
      </div>
    </StyledCardGridLayoutContainer>
  )
}

export default CardGridLayoutContainer
